import { render, staticRenderFns } from "./BackToBoard.vue?vue&type=template&id=fb1f558c&"
import script from "./BackToBoard.vue?vue&type=script&lang=js&"
export * from "./BackToBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports